import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Settings } from '@/features/painel-administrativo/settings/Settings';

export const Route = createFileRoute('/admin/_a/configuracao/representante')({
    component: Settings,
    validateSearch: z.object({
        menu: z.string().optional(),
        tab: z.string().optional(),
    }),
});
